import { NavLink } from 'react-router-dom'
import InventoryTabs from './InventoryTabs'

const LINKS = [
  { to: '/inventory/sku-bins', label: 'Where is it?' },
  { to: '/inventory/bin-move-sku', label: 'Put away & move' },
  { to: '/inventory/bin-adjust-sku', label: 'Count a bin' },
  { to: '/inventory/areas', label: 'Storage areas' },
]

// Header for the bin-tracking pages: the Inventory tabs, the page title and
// the bin tools as chips.
export default function BinNav({ title, meta, actions }) {
  return (
    <>
      <InventoryTabs />
      <div className="ci-header-row">
        <div className="ci-title-block">
          <div>
            <h1>{title}</h1>
            {meta && <div className="ci-title-meta">{meta}</div>}
          </div>
        </div>
        {actions && <div className="ci-header-actions">{actions}</div>}
      </div>
      <nav className="filter-chips" aria-label="Bin tools">
        {LINKS.map((l) => (
          <NavLink key={l.to} to={l.to} className={({ isActive }) => `filter-chip${isActive ? ' active' : ''}`}>{l.label}</NavLink>
        ))}
      </nav>
    </>
  )
}
